<template>
  <div>
    <div class="steptracking-container">
      <h3 class="summary-title">
        {{ $t('tracking.delivery.FiveStepsLabel') }}
      </h3>
      <div class="line-block" id="suivie_mon_colis">
        <div v-for="(step, index) in steps" :key="step.Numero || index" class="step-container">
          <div
            class="col-md-2 col-sm-2 col-2 step"
            :class="{
              last: step.Numero === 5,
              takenContainer: isTaken(step) || step.Numero === 5,
              validate: isValidated(step),
              lastTaken: index == lastTakenIndex,
            }"
          >
            <div class="step-content">
              <div v-if="isValidated(step)" class="step-icon">
                <img :src="checkIconSrc" :alt="$t('tracking.alt.valid_picto')" />
              </div>

              <div v-else class="step-icon not-validated" aria-hidden="true"></div>
            </div>

            <p class="step-label" :class="{ taken: isTaken(step) }">
              {{ step.Libelle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['fiveStepsTracking', 'nameTheme']),
    steps() {
      const vals = Object.values(this.fiveStepsTracking || {});
      return vals.sort((a, b) => (a?.Numero || 0) - (b?.Numero || 0));
    },
    lastTakenIndex() {
      let last = -1;
      this.steps.forEach((s, idx) => {
        if (s?.Evenement?.Date) last = idx;
      });
      return last;
    },
    checkIconSrc() {
      if ((this.nameTheme || '').toLowerCase() === 'inpost') {
        return '/Scripts/vue/tracking/img/inpost/ico_green_check.svg';
      }
      return '/Scripts/vue/tracking/img/mondialrelay/ico_green_check.svg';
    },
  },
  methods: {
    isTaken(step) {
      return !!step?.Evenement?.Date;
    },
    isValidated(step) {
      return this.isTaken(step);
    },
  },
};
</script>

<style scoped lang="scss">
@import './FiveStepsTracking.scss';
</style>
